export default "__VITE_ASSET__C48gr9ct__"